"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _InfoCircleOutlined = _interopRequireDefault(require("@foxui/ui-icons-svg/lib/asn/InfoCircleOutlined"));
var _AntdIcon = _interopRequireDefault(require("../components/AntdIcon"));
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var InfoCircleOutlined = function InfoCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
    ref: ref,
    icon: _InfoCircleOutlined.default
  }));
};

/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMTdhMSAxIDAgMDEtMS0xdi00YTEgMSAwIDExMiAwdjRhMSAxIDAgMDEtMSAxek0xMyA4YTEgMSAwIDAxLTEgMWgtLjAxYTEgMSAwIDExMC0ySDEyYTEgMSAwIDAxMSAxeiIgLz48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMyAxMmExMSAxMSAwIDExLTIyIDAgMTEgMTEgMCAwMTIyIDB6bS0xMSA5YTkgOSAwIDEwMC0xOCA5IDkgMCAwMDAgMTh6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/React.forwardRef(InfoCircleOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'InfoCircleOutlined';
}
var _default = exports.default = RefIcon;